import { render, staticRenderFns } from "./TransferDocumentDropoffForm.vue?vue&type=template&id=f78d0d1e"
import script from "./TransferDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./TransferDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports